import { useMemo } from 'react';
import type { CSSProperties } from 'react';
import { useTheme } from '@course-authoring/shared-types';

export interface ToastProps {
  /** Message to announce; renders nothing while null. */
  message: string | null;
}

export function Toast({ message }: ToastProps) {
  const { tokens } = useTheme();
  const styles = useMemo(() => createStyles(tokens), [tokens]);

  if (!message) return null;

  return (
    <div style={styles.toast} role="status" aria-live="polite">
      {message}
    </div>
  );
}

function createStyles(tokens: ReturnType<typeof useTheme>['tokens']): Record<string, CSSProperties> {
  return {
    toast: {
      position: 'fixed',
      bottom: '24px',
      left: '50%',
      transform: 'translateX(-50%)',
      maxWidth: 'calc(100vw - 32px)',
      boxSizing: 'border-box',
      backgroundColor: tokens.backgrounds.inverse,
      color: tokens.text.onInverse,
      padding: '10px 18px',
      borderRadius: tokens.radius.md,
      fontSize: '14px',
      boxShadow: tokens.shadow.lg,
      // Above ModalShell (1000) so a toast raised as a dialog closes is never hidden.
      zIndex: 1100,
    },
  };
}
